import React, { useState, useEffect } from 'react';
import { Table, Card, Layout, Menu } from 'antd';
import {
  DashboardOutlined,
  EditOutlined,
  FileSearchOutlined,
} from '@ant-design/icons';
import { BrowserRouter as Router, Switch, Route, Link, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import Sidebar from '../../Side_Bar/Customer_Side_Bar';
import { loadUserData  } from "../../User_Data.js";

const { Sider, Content } = Layout;


const DataTables = () => {
  // Dummy data for the main table
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(loadUserData());
  const [isLoading, setIsLoading] = useState(true);
  const [contract_data, setContractData] = useState([]);
  const [contract_id, setContractId] = useState(0);
  const [pricing_data, setPricingData] = useState([]);

  const mainUrl                       = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";
  useEffect(() => {
    const fetchData = async () => {
      try {
        const customerResponse = await fetch(`${mainUrl}/getCustomerWithUsername?username=${userData.username}`);
        if (!customerResponse.ok) {
          throw new Error(`HTTP error! Status: ${customerResponse.status}`);
        }
        const customer_data = await customerResponse.json();

        const customer_id = customer_data[0].customer_id;

        try {
          const contractResponse = await fetch(`${mainUrl}/getContractWithCustomerID?customer_id=${customer_id}`);
          if (!contractResponse.ok) {
            throw new Error(`HTTP error! Status: ${contractResponse.status}`);
          }
          const c_data = await contractResponse.json();
          setContractData(c_data);
          setIsLoading(false);
        
        } catch (error) {
          console.error('Error fetching table data:', error);
          throw error;
        }

      } catch (error) {
        console.error('Error fetching table data:', error);
        throw error;
      }
    };

    fetchData();
  }, [])

  useEffect (() =>{
    const fetchData = async ()=>{
      try {
        const pricingResponse = await fetch(`${mainUrl}/getTable?tableName=Customer_Pricing&contract_id=${contract_id}`);
        if (!pricingResponse.ok) {
          throw new Error(`HTTP error! Status: ${pricingResponse.status}`);
        }
        const pricing_data = await pricingResponse.json();
        setPricingData(pricing_data);
        setIsLoading(false);
        console.log(pricing_data)
      
      } catch (error) {
        console.error('Error fetching table data:', error);
        throw error;
      }
    }

    fetchData();
  }, [contract_id])

  const mainTableData = [
    {
      key: 1,
      type: 'Type 1',
      description: 'Description 1',
      messageQuota: 1000,
      prepaidAmount: 500,
      tenureStartDate: '2022-01-01',
      tenureEndDate: '2023-01-01',
      tenureDuration: '1 year',
    },
    {
      key: 2,
      type: 'Type 2',
      description: 'Description 2',
      messageQuota: 2000,
      prepaidAmount: 1000,
      tenureStartDate: '2023-01-01',
      tenureEndDate: '2024-01-01',
      tenureDuration: '1 year',
    },
    // Add more rows as needed
  ];

  // Dummy data for the detailed table
  const [selectedRow, setSelectedRow] = useState(null);

  const detailedTableData = [
    {
      key: 0,
      authenticationCost: 50,
      serviceCost: 100,
      utilityCost: 30,
      marketingCost: 20,
      unknownType: 10,
    },
    {
      key: 1,
      authenticationCost: 60,
      serviceCost: 120,
      utilityCost: 35,
      marketingCost: 25,
      unknownType: 15,
    },
    // Add more rows as needed
  ];

  // Columns for the main table
  const mainColumns = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Message Quota',
      dataIndex: 'monthly_message_quota',
      key: 'monthly_message_quota',
    },
    {
      title: 'Pre-paid Amount',
      dataIndex: 'prepaid_amount',
      key: 'prepaid_amount',
    },
    {
      title: 'Tenure Start Date',
      dataIndex: 'start_date',
      key: 'start_date',
    },
    {
      title: 'Tenure End Date',
      dataIndex: 'end_date',
      key: 'end_date',
    },
    {
      title: 'Tenure Duration',
      dataIndex: 'monthly_duration',
      key: 'monthly_duration',
    },
  ];

  // Columns for the detailed table
  const detailedColumns = [
    {
      title: 'Authentication Cost',
      dataIndex: 'authentication',
      key: 'authentication',
    },
    {
      title: 'Service Cost',
      dataIndex: 'service',
      key: 'service',
    },
    {
      title: 'Utility Cost',
      dataIndex: 'utility',
      key: 'utility',
    },
    {
      title: 'Marketing Cost',
      dataIndex: 'marketing',
      key: 'marketing',
    },
    {
      title: 'Unknown Type',
      dataIndex: 'unknown_type',
      key: 'unknown_type',
    },
    {
      title: 'Session Cost',
      dataIndex: 'session',
      key: 'session',
    },
  ];

  const onRowClick = (record) => {
    setSelectedRow(record.contract_id);
    setContractId(record.contract_id);
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar location={location} />
      <Layout>
        <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', fontFamily: 'Helvetica, Arial, sans-serif' }}>
          <Card title={<span style={{ fontSize: '20px' }}> Subscription Details</span>} style={{ maxWidth: '1200px' }}>
            <Table
              dataSource={contract_data}
              columns={mainColumns}
              onRow={(record) => ({
                onClick: () => onRowClick(record),
              })}
            />
            {selectedRow && (
              <Table
                dataSource={pricing_data}
                columns={detailedColumns}
                style={{ marginTop: '20px' }}
              />
            )}
          </Card>
        </div>
      </Layout>
    </Layout>

  );
};

export default DataTables;
